import { useEffect, useState } from 'react'
import { Copy } from 'lucide-react'
import type { FallbackProps } from 'react-error-boundary'
import { toast } from 'sonner'
import { useLocation } from 'react-router'
import { useAuthStore, type User } from 'shared/store/auth'
import { Button } from 'shared/components/ui/button'
import { useTranslate } from 'shared/lib/i18n'

export function ErrorFallbackMain({ resetErrorBoundary, error }: FallbackProps) {
	const { t } = useTranslate()
	const { pathname } = useLocation()
	const [url] = useState(pathname)
	const { user } = useAuthStore()

	useEffect(() => {
		if (url !== pathname) resetErrorBoundary()
	}, [pathname, url, resetErrorBoundary])

	useEffect(() => {
		toast.error(<ErrorMessageMain user={user} pathname={pathname} />)
	}, [error, user, pathname])

	return (
		<div className='flex items-center gap-5'>
			{t('errors.unexpected')}
			<Button variant='outline' onClick={() => resetErrorBoundary()}>
				{t('common.retry')}
			</Button>
		</div>
	)
}

type ErrorMessageProps = {
	user: User
	pathname: string
}
const ErrorMessageMain = ({ user, pathname }: ErrorMessageProps) => {
	const { t } = useTranslate()
	const copyToClipboard = () => {
		navigator.clipboard.writeText(
			`role: ${user.role}; username: ${user.username}; \n ${pathname}`
		)
		toast.success(t('common.copied'))
	}

	return (
		<div className='w-full flex gap-1 items-center justify-between'>
			<p>{t('errors.copyMessage')} --&gt;</p>
			<button onClick={copyToClipboard} className=''>
				<Copy />
			</button>
		</div>
	)
}

export const ErrorTrigger = () => {
	const [hasError, setHasError] = useState(false)
	if (hasError) throw new Error('Test error')
	return <button onClick={() => setHasError(true)}>Trigger Error</button>
}
